module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap-widget"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "cc-loader"
  }, [_c('div', {
    staticClass: "spinner"
  })]) : _c('div', [(!_vm.fetchError) ? _c('div', [_c('highcharts', {
    attrs: {
      "options": _vm.options
    }
  })], 1) : _c('div', {
    staticClass: "alert alert-error"
  }, [_vm._v("\n            " + _vm._s(_vm.fetchError) + "\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77e634d2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/widget-highcharts-3.vue
// module id = 229
// module chunks = 0